import apiClient from "../common/apiClient";

export default class PatientController {
    async Create(data, token) {
        try {
            return await apiClient.post("/patient", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(departmentId, data, token) {
        try {
            return await apiClient.put("/patient/" + departmentId, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/patient/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllPatient(token) {
        try {
            return await apiClient.get("/getAllPatient", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
    async GetPatientFamily(data, token) {
        try {
            return await apiClient.post("/getPatientFamily", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
